import {
  Box,
  Button, Input, InputAdornment,
  Stack, Table, TableBody, TableCell, TableHead, TableRow, Tooltip,
  Typography
} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {IconAlertCircle, IconPlus, IconSearch} from "@tabler/icons-react";
import {AppContext} from "../../../../context/AppContext";
import {collection, onSnapshot, orderBy, query, where, and, or} from "firebase/firestore";
import {auth, db} from "../../../../config/firebase";
import {LicenseRow} from "./license-row";

export const SigneesView = ({nft, license, onSelectSign, onCreateSign}) => {
  const [search, setSearch] = useState("");

  const [notifications, setNotifications] = useState([])
  const {state: {userDetails}} = useContext(AppContext);

  useEffect(() => {
    const fetchNotifications = () => {
      let unsubscribe = null;
      try {
        const notificationsQuery = query(
          collection(db, "license_requests"),
          and(
            or(
              where("email", "==", userDetails?.email),
              where("recipientMail", "==", userDetails?.email)
            ),
            where("licenseUid", "==", license?.uid),
          ),
          orderBy("createdAt", "desc")
        );
        console.log("Fetch license requests")
        unsubscribe = onSnapshot(notificationsQuery, (querySnapshot) => {
          let notifications = [];
          querySnapshot.forEach(doc => {
            const data = doc.data();
            notifications.push(data);
          });
          console.log(notifications);
          setNotifications(notifications);
        });
      } catch (error) {
        console.log(error);
      }
      return unsubscribe;
    }
    if (userDetails && userDetails?.email) {
      const unsubscribe = fetchNotifications();
      return () => {
        if (unsubscribe) {
          unsubscribe();
        }
      }
    }
  }, [userDetails])

  const isLicenseOnly = nft?.userUid !== auth.currentUser.uid

  return (
    <>
      <Stack direction={"row"} gap={2} alignItems={"center"} sx={{py: 1}}>
        <Typography sx={{fontWeight: 600, fontSize: "1.1rem"}}>Licenses</Typography>
        <Typography sx={{fontWeight: 400, fontSize: "1rem"}} className={"text-grey"}>
          {notifications?.length} licenses in operation
        </Typography>
        <Box sx={{flex: 1, fontWeight: 600, textAlign: "right"}}>
          <Input
            placeholder={"Search for signee"}
            value={search} onChange={(e) => setSearch(e.target.value)}
            startAdornment={<InputAdornment position={"start"}><IconSearch /></InputAdornment>}
          />
        </Box>
        <Box sx={{fontWeight: 600, textAlign: "right"}}>
          <Button className={license?.archive || isLicenseOnly ? "" : "gradient-text"} onClick={onCreateSign} disabled={license?.archive || isLicenseOnly}
                  startIcon={<IconPlus className={license?.archive || isLicenseOnly ? "" : "text-purple"} size={18}/>}>
            Send License
          </Button>
        </Box>
      </Stack>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell className={"text-grey"} sx={{fontWeight: 600}}>Recipient Mail</TableCell>
            <TableCell className={"text-grey"} sx={{fontWeight: 600}}>Date</TableCell>
            <TableCell className={"text-grey"} sx={{fontWeight: 600}}>Expiration</TableCell>
            <TableCell className={"text-grey"} sx={{fontWeight: 600}}>Type</TableCell>
            <TableCell className={"text-grey"} sx={{fontWeight: 600}}></TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {
            notifications?.length === 0 ?
              <TableRow>
                <TableCell colSpan={6}>{"You don't have any notifications"}</TableCell>
              </TableRow>
              : null
          }
          {
            notifications?.map(notification => {


              return (
                <LicenseRow key={notification?.id || notification?.uid} request={notification} />
              )
            })
          }
        </TableBody>
      </Table>
    </>
  )
}
